import React, { Component } from 'react'
import PropTypes from 'prop-types'
import storeData from 'sb-store-data'
import { constants } from 'common/helpers'
import actions from 'redux/actions'
import { FormattedMessage } from 'sb-react-intl'

import { openChangeFrequencySuccessModal } from 'compositions/modals/changeFrequency'
import ConfirmModal from 'components/modals/ConfirmModal/ConfirmModal'

import messages from './messages'


class NeedChangeFrequencyModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    plan: PropTypes.object,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    data: PropTypes.shape({
      isMoveAction: PropTypes.bool,
      onCancel: PropTypes.func,
    }),
  }

  static defaultProps = {
    name: constants.modals.limitedEditionProducts.NeedChangeFrequency,
    title: messages.title,
    plan: {},
  }

  handleClickChangeFrequency = () => {
    const { plan: { name: planName, nextShippingDate, shippingPeriod }, data: { isMoveAction } } = this.props

    this.close()
    actions.models.ui.showRequestLoader()
    actions.models.subscription.changePlan(planName, 'lep add to queue popup')
      .finally(() => {
        actions.models.ui.hideRequestLoader()
      })
      .then(() => {
        openChangeFrequencySuccessModal({ nextShippingDate, shippingPeriod })

        if (!isMoveAction) {
          actions.models.queue.resolveAllPostponedLimitedItems()
        }
      })
      .catch(({ error }) => {
        // TODO Recurly. remove this logic - added on 5/21/20 by pavelivanov
        if (error === 'change_plan') {
          if (!isMoveAction) {
            actions.models.queue.removeAllPostponedLimitedItems()
          }

          actions.models.payment.setUnpause(true)
        }
      })
  }

  onCancel = () => {
    const { data: { onCancel, isMoveAction } } = this.props

    if (!isMoveAction) {
      actions.models.queue.resolveAllPostponedLimitedItems({ force: true })
    }

    if (typeof onCancel === 'function') {
      onCancel()
    }

    this.close()
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, title } = this.props

    return (
      <ConfirmModal
        name={name}
        title={title}
        id={name}
        confirmTitle={messages.confirmButton}
        cancelTitle={messages.cancelButton}
        onConfirm={this.handleClickChangeFrequency}
        onCancel={this.onCancel}
        withTextCancel
      >
        <FormattedMessage {...messages.text} />
      </ConfirmModal>
    )
  }
}


export default storeData({
  plan: () => actions.models.subscription.fetchFrequencies()
    .then((result) => result.find(({ shippingPeriod }) => shippingPeriod === 1)),
})(NeedChangeFrequencyModal)
